'use es6';

import PropTypes from 'prop-types';
import { BaseResponsiveToolbar, buildActionsForModuleInDndArea } from './BaseResponsiveToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileModuleToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  isCommentable
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInDndArea({
      isInNonDefaultBreakpointMode,
      isCommentable
    }),
    responsiveSize: responsiveSize,
    isCommentable: isCommentable
  });
};
MockResponsiveMobileModuleToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  isCommentable: PropTypes.bool
};
const MockResponsiveDesktopModuleToolbarToMeasure = ({
  responsiveSize,
  isCommentable
}) => {
  if (window.SELENIUM_IS_RUNNING) {
    console.warn(`Rendered MockResponsiveDesktopModuleToolbarToMeasure, with responsiveSize: ${responsiveSize}`);
  }
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInDndArea({
      isCommentable
    }),
    responsiveSize: responsiveSize,
    isCommentable: isCommentable
  });
};
MockResponsiveDesktopModuleToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isCommentable: PropTypes.bool
};
const MockResponsiveDesktopModuleWithoutAccessToolbarToMeasure = ({
  responsiveSize,
  isAdvancedModuleWithoutAccess,
  isCommentable
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInDndArea({
      isAdvancedModuleWithoutAccess
    }),
    responsiveSize: responsiveSize,
    isCommentable: isCommentable
  });
};
MockResponsiveDesktopModuleWithoutAccessToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isAdvancedModuleWithoutAccess: PropTypes.bool.isRequired,
  isCommentable: PropTypes.bool
};
const MockResponsiveDesktopEditableModuleWithoutAccessToolbarToMeasure = ({
  responsiveSize,
  isAdvancedModuleWithoutAccess,
  isCommentable
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInDndArea({
      isAdvancedModuleWithoutAccess,
      moduleType: 'rich_text'
    }),
    responsiveSize: responsiveSize,
    isCommentable: isCommentable
  });
};
MockResponsiveDesktopEditableModuleWithoutAccessToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isAdvancedModuleWithoutAccess: PropTypes.bool.isRequired,
  isCommentable: PropTypes.bool
};
const MockResponsiveMobileModuleWithoutAccessToolbarToMeasure = ({
  responsiveSize,
  isAdvancedModuleWithoutAccess,
  isInNonDefaultBreakpointMode = true,
  isCommentable
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveToolbar, {
    actions: buildActionsForModuleInDndArea({
      isAdvancedModuleWithoutAccess,
      isInNonDefaultBreakpointMode,
      moduleType: undefined,
      isCommentable
    }),
    responsiveSize: responsiveSize,
    isCommentable: isCommentable
  });
};
MockResponsiveMobileModuleWithoutAccessToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isAdvancedModuleWithoutAccess: PropTypes.bool.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  isCommentable: PropTypes.bool
};
export { MockResponsiveMobileModuleToolbarToMeasure, MockResponsiveDesktopModuleToolbarToMeasure, MockResponsiveDesktopModuleWithoutAccessToolbarToMeasure, MockResponsiveDesktopEditableModuleWithoutAccessToolbarToMeasure, MockResponsiveMobileModuleWithoutAccessToolbarToMeasure };